export const validatePassword = (password) => {
    const minLength = 8;
    const isValidLength = password.length >= minLength;
    if (!isValidLength) {
        return {
            isValid: false,
            error: `Password must be at least ${minLength} characters long.`,
        };
    }

    const complexityRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_])/;
    const matchesComplexity = complexityRegex.test(password);

    if (!matchesComplexity) {
        return {
            isValid: false,
            error: 'The password should contain 1 Upper Case letter, 1 Lower Case letter, 1 Number and a Special Character.',
        };
    }

    return { isValid: true, error: null };
};
